<template>
    <div id="ActivityItem">
        <div class="activity-card-title-group">
            <h3 class="f24 f18-mb black lh15">
                {{ props.item.eventName }}
            </h3>
            <h4 class="f14 f14-mb lh15">{{ props.item.organizer }}</h4>
        </div>
        <ul class="activity-card-info-group">
            <li class="prefix-list-item">
                <i class="icon-calendar"></i>
                <div>
                    <h5 class="head">活動時間</h5>
                    <h4 class="body">
                        {{
                            moment(props.item.startTime).format(
                                'YYYY/MM/DD hh:mm'
                            )
                        }}
                    </h4>
                </div>
            </li>
            <li class="prefix-list-item">
                <i class="icon-people"></i>
                <div>
                    <h5 class="head">參與人數</h5>
                    <h4 class="body">
                        {{ props.item.participateNum.toLocaleString('en-US') }}
                    </h4>
                </div>
            </li>
            <li class="prefix-list-item">
                <i class="icon-location"></i>
                <div>
                    <h5 class="head">活動地區</h5>
                    <h4 class="body">
                        {{ props.item.cityName }}
                    </h4>
                </div>
            </li>
            <li class="prefix-list-item">
                <i class="icon-coastline"></i>
                <div>
                    <h5 class="head">海岸線</h5>
                    <h4 class="body">
                        {{ props.item.location }}
                    </h4>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'ActivityItem',
}
</script>
<script setup>
import moment from 'moment'

const props = defineProps({
    item: Object,
})
</script>
<style lang="scss" scoped>
#ActivityItem {
    @media screen and (min-width: 768px) {
        margin-bottom: 20px;
        padding: 40px 30px 30px;
        box-shadow: $shadow1;
    }
    @media screen and (max-width: 767px) {
        margin: 5px;
        padding: 20px;
        background-color: $white;
    }
}
.activity-card-title-group {
    margin-bottom: 20px;
    h3 {
        color: $theme3;
    }
    h4 {
        color: $grayA;
    }

    @media screen and (min-width: 768px) {
        display: flex;
        justify-content: space-between;
        h3 {
            flex: 1 1 70%;
        }
        h4 {
            flex: 1 1 30%;
            margin-left: 20px;
            text-align: right;
        }
    }
    @media screen and (max-width: 767px) {
    }
}
.activity-card-info-group {
    padding-right: 15%;
    display: flex;
    flex-wrap: wrap;
    li.prefix-list-item {
        margin: 10px 0;
        flex: 1 40%;
        color: $gray6;
        i {
            color: $theme1;
        }
    }
}
</style>
